import React from 'react';

interface Props {
  title?: React.ReactNode;
  description?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
  bodyClassName?: string;
  interactive?: boolean;
  padded?: boolean;
  children: React.ReactNode;
}

const Card: React.FC<Props> = ({
  title,
  description,
  actions,
  className = '',
  bodyClassName = '',
  interactive = false,
  padded = true,
  children,
}) => {
  const base =
    'rounded-2xl border border-slate-200 bg-white shadow-card transition-all duration-200';
  const interactiveClasses = interactive
    ? 'hover:border-slate-300 hover:shadow-md cursor-pointer'
    : '';

  const hasHeader = title || actions || description;

  return (
    <div className={`${base} ${interactiveClasses} ${className}`}>
      {hasHeader && (
        <div className="flex items-start justify-between gap-4 border-b border-slate-200 px-5 py-4">
          <div className="min-w-0">
            {title && (
              <h3 className="truncate font-display text-lg font-medium tracking-tight text-slate-900">
                {title}
              </h3>
            )}
            {description && (
              <p className="mt-1 text-sm text-slate-600">{description}</p>
            )}
          </div>
          {actions && (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          )}
        </div>
      )}
      <div className={`${padded ? 'p-5' : ''} ${bodyClassName}`}>{children}</div>
    </div>
  );
};

export default Card;
